import type { TimeLimitHandler } from './types';

export class FailSafeTimeLimitHandler implements TimeLimitHandler {
  public canStart(): boolean {
    return false;
  }

  public getEndDate(): number {
    return 0;
  }

  public getStartDate(): number {
    return 0;
  }

  public hasEnded(): boolean {
    return true;
  }

}
